document.querySelectorAll(".jsCloseErr").forEach((btn) => {
    btn.addEventListener("click", () => {
        const box = btn.closest(".msg-err");
        if (box) box.classList.add("hidden");
    });
});
